import styled from 'styled-components';
import { prop } from 'ramda';

import { CHART_TITLE_COLOR } from '../../../utils/colors';

const yLabelOffset = (yDot, fontSize) => `calc(${yDot}px + 0.7 * ${fontSize})`;

const labelStyles = ({ xDot, yDot, fontSize }) => ({
  style: {
    transform: `translate(${xDot}px, ${yLabelOffset(yDot, fontSize)})`,
  },
});

export const AxisLabel = styled.text.attrs(labelStyles)`
  font-size: ${prop('fontSize')};
  font-weight: 500;
  fill: ${CHART_TITLE_COLOR};
`;

export const DotLabel = styled.text.attrs(labelStyles)`
  font-size: ${prop('fontSize')};
  text-anchor: middle;
  font-weight: 500;
  fill: ${prop('color')};
`;

export const LineGroup = styled.g`
  transition: opacity 0.3s ease-in;
  opacity: ${({ isHoverActive, isGroupHovered }) => (isHoverActive && !isGroupHovered ? 0.3 : 1)};
`;

export const MoreText = styled.tspan`
  font-weight: 200;
  font-size: 0.8em;
`;

export const ItemTooltipList = styled.div`
  max-width: 150px;
  font-size: 0.9em;
  color: ${CHART_TITLE_COLOR};
`;